import React, { forwardRef } from "react";
import { MDBBtn, MDBCol, MDBRow } from "mdb-react-ui-kit";
import moment from "moment";
import { useStore } from "@/store/index";
import styles from "../../../../styles/detail/DetailAddToCart.module.scss";
import contactsSvg from "../../../../utils/svg-icon/contacts";
import CloseLine from "../../../../utils/svg-icon/userInterface";

const DatePickerRangeButton = forwardRef<
    HTMLAllCollection,
    {
        startDate: Date | null;
        rangeLength: number;
        label?: string;
        onClick?: () => void;
        setClick?: React.Dispatch<React.SetStateAction<boolean>>;
        click?: boolean;
        setIsClosed: React.Dispatch<React.SetStateAction<boolean>>;
        isConfirm?: boolean;
        setIsConfirm: React.Dispatch<React.SetStateAction<boolean>>;
        setStartDateView: (date: Date | null) => void;
        onDeleteRange?: () => void;
    }
>(
    (
        {
            startDate,
            rangeLength,
            label = "Select your vacation dates",
            onClick,
            click,
            setClick,
            setIsClosed,
            isConfirm,
            setIsConfirm,
            setStartDateView,
            onDeleteRange,
        },
        ref
    ) => {
        const formatPattern = "MMMM D, YYYY";
        const firstDate = () =>
            moment(startDate).format(formatPattern).split(",");

        const getEndDate = () => {
            return moment(startDate)
                .add(rangeLength - 1, "days")
                .format(formatPattern)
                .split(",");
        };

        const dispatch = useStore(state => state.dispatchCheckout);

        return (
            <div>
                {click && isConfirm && firstDate().at(0) !== "Invalid date" ? (
                    <MDBBtn
                        className={`${styles.calendarContainer} ${
                            click ? `${styles.calendarContainerClick}` : ""
                        }`}
                        noRipple
                        outline
                        onClick={() => setIsClosed(false)}
                    >
                        <MDBRow className="w-100 ">
                            <MDBCol
                                size={12}
                                ref={ref}
                                className="mx-0 square border-3 justify-content-center pb-2 pb-md-0"
                                style={{
                                    cursor: "pointer",
                                    borderColor: "#E6E8EC",
                                }}
                            >
                                <MDBRow className="flex-nowrap gap-2">
                                    <MDBRow
                                        center
                                        className={`${styles.dateText} p-0 m-0 position-relative`}
                                    >
                                        <p
                                            className="m-0"
                                            // style={{ width: "fit-content" }}
                                            onClick={onClick}
                                        >
                                            {`${firstDate().at(0)},`}
                                            {firstDate().at(1)} -{" "}
                                            {`${getEndDate().at(0)},`}
                                            {getEndDate().at(1)}
                                        </p>
                                        <span
                                            className="m-0 p-0"
                                            style={{
                                                width: "auto",
                                                position: "absolute",
                                                right: "0",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    zIndex: "100000",
                                                }}
                                                onClick={() => {
                                                    if (setClick) {
                                                        if (onDeleteRange)
                                                            onDeleteRange();
                                                        setStartDateView(null);
                                                        // const url = new URL(
                                                        //     window.location.href
                                                        // );
                                                        // url.searchParams.set(
                                                        //     "clickDate",
                                                        //     false as unknown as string
                                                        // );
                                                        // url.searchParams.set(
                                                        //     "isConfirm",
                                                        //     false as unknown as string
                                                        // );
                                                        // window.history.replaceState(
                                                        //     null,
                                                        //     "",
                                                        //     url
                                                        // );
                                                        setClick(false);
                                                        setIsConfirm(false);
                                                        dispatch({
                                                            type: "SET_CLICKDATE",
                                                            payload: false,
                                                        });
                                                        dispatch({
                                                            type: "SET_CLICKCONFIRMDATE",
                                                            payload: false,
                                                        });
                                                    }
                                                }}
                                            >
                                                <CloseLine.CloseLine />
                                            </div>
                                        </span>
                                    </MDBRow>
                                </MDBRow>
                            </MDBCol>
                        </MDBRow>
                    </MDBBtn>
                ) : (
                    <MDBBtn
                        className={`${styles.calendarContainer}`}
                        noRipple
                        outline
                        onClick={() => setIsClosed(false)}
                    >
                        <MDBRow
                            className="w-100 "
                            onClick={() => {
                                if (setClick) {
                                    // const url = new URL(window.location.href);
                                    // url.searchParams.set(
                                    //     "clickDate",
                                    //     true as unknown as string
                                    // );
                                    // window.history.replaceState(null, "", url);
                                    setClick(true);
                                    dispatch({
                                        type: "SET_CLICKDATE",
                                        payload: true,
                                    });
                                }
                            }}
                        >
                            <MDBCol
                                size={12}
                                onClick={onClick}
                                ref={ref}
                                className={` mx-0 square border-3 justify-content-center pb-2 pb-md-0`}
                                style={{
                                    cursor: "pointer",
                                    borderColor: "#E6E8EC",
                                }}
                            >
                                <MDBRow className="flex-nowrap gap-2 justify-content-center">
                                    <MDBRow
                                        center
                                        className={`${styles.dateText} p-0 m-0`}
                                    >
                                        <span
                                            className="m-0 p-0"
                                            style={{ width: "fit-content" }}
                                        >
                                            {label}
                                        </span>
                                        <span
                                            className="m-0 p-0"
                                            style={{ width: "24px" }}
                                        >
                                            <contactsSvg.CalendarLine />
                                        </span>
                                    </MDBRow>
                                </MDBRow>
                            </MDBCol>
                        </MDBRow>
                    </MDBBtn>
                )}
            </div>
        );
    }
);

export default DatePickerRangeButton;
